"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";

// Indicatifs FR + voisins francophones. Le 1er est le défaut.
export const COUNTRIES = [
  { code: "FR", flag: "🇫🇷", dial: "+33" },
  { code: "BE", flag: "🇧🇪", dial: "+32" },
  { code: "CH", flag: "🇨🇭", dial: "+41" },
  { code: "LU", flag: "🇱🇺", dial: "+352" },
  { code: "CA", flag: "🇨🇦", dial: "+1" },
  { code: "MA", flag: "🇲🇦", dial: "+212" },
];

// Normalise : accepte "06…", "+336…", "00336…" -> renvoie du E.164 (+336…)
export function normalizePhone(raw: string, dial: string): string {
  let v = raw.replace(/[\s.\-()]/g, "");
  if (!v) return "";
  if (v.startsWith("+")) return v;
  if (v.startsWith("00")) return "+" + v.slice(2);
  if (v.startsWith("0")) return dial + v.slice(1);
  return dial + v;
}

export function PhoneField({
  onChange,
  invalid = false,
}: {
  onChange: (normalized: string) => void;
  invalid?: boolean;
}) {
  const [country, setCountry] = useState(COUNTRIES[0]);
  const [raw, setRaw] = useState("");

  const push = (r: string, dial: string) => {
    setRaw(r);
    onChange(normalizePhone(r, dial));
  };

  return (
    <label className="block">
      <span className="mb-1.5 block text-xs font-medium text-ink/55">
        Téléphone (pour recevoir votre ressource par message)
      </span>
      <div
        className={cn(
          "flex items-stretch overflow-hidden rounded-xl border bg-ink/[0.03] transition focus-within:border-gold",
          invalid ? "border-red-500/70" : "border-ink/15"
        )}
      >
        <select
          aria-label="Indicatif pays"
          value={country.code}
          onChange={(e) => {
            const c = COUNTRIES.find((x) => x.code === e.target.value)!;
            setCountry(c);
            push(raw, c.dial);
          }}
          className="border-r border-ink/15 bg-transparent py-3 pl-3 pr-1 text-sm text-ink outline-none"
        >
          {COUNTRIES.map((c) => (
            <option key={c.code} value={c.code}>
              {c.flag} {c.dial}
            </option>
          ))}
        </select>
        <input
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          value={raw}
          onChange={(e) => push(e.target.value, country.dial)}
          placeholder="06 12 34 56 78"
          className="w-full bg-transparent px-3.5 py-3 text-sm text-ink outline-none placeholder:text-ink/40"
        />
      </div>
      <span className="mt-1 block text-[11px] text-ink/45">
        Format local (06…) ou international (+33…)
      </span>
    </label>
  );
}
